"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchToastModal = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("@amzn/atoz-web/Button");
var Text_1 = require("@amzn/atoz-web/Text");
var View_1 = require("@amzn/atoz-web/View");
var Modal_1 = require("@amzn/atoz-web/Modal");
var react_i18next_1 = require("react-i18next");
var Theme_1 = require("@amzn/atoz-web/Theme");
var PunchToastIcon_1 = require("../PunchToastIcon");
var PunchToastModal = function (_a) {
    var dataTestId = _a.dataTestId, title = _a.title, text = _a.text, status = _a.status, closeModal = _a.closeModal;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(Modal_1.ModalContent, { dataTestId: dataTestId || 'PunchToastModal', onCloseButtonClick: closeModal, titleText: "", buttons: [
            react_1.default.createElement(Button_1.Button, { style: { width: '100%' }, key: "PunchToastModalConfirmButton", variant: Button_1.ButtonVariant.Primary, dataTestId: "PunchToastModalConfirmButton", onClick: closeModal }, t('time_and_attendance_PunchToastModal_Ok'))
        ] },
        react_1.default.createElement(View_1.View, { margin: { top: 'S500' } },
            react_1.default.createElement(IconTitleWrapper, null,
                react_1.default.createElement(PunchToastIcon_1.PunchToastIcon, { status: status }),
                react_1.default.createElement(Text_1.Text, { fontSize: "T500", margin: { top: 'S200' } }, title)),
            react_1.default.createElement(Text_1.Text, null, text))));
};
exports.PunchToastModal = PunchToastModal;
var IconTitleWrapper = (0, Theme_1.styledWithTheme)(View_1.View)(function (_a) {
    var theme = _a.theme;
    return "\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ".concat(theme.selectors.space('S200'), "px;\n  ");
});
